import { QueueSettingEnum } from "../enums";

/**Модель для описания статусов/тегов/приоритетов */
export class ExtensionModel {
  /**Id расширения */
  Id?: number;
  /**Цвет */
  Color?: string;
  /**Имя */
  Name?: string = "";
  /**Данный объект выбран "По умолчанию" */
  IsDefault?: boolean;
  /**Описание */
  Description?: string;

  constructor(obj?: Partial<ExtensionModel>) {
    if (obj) Object.assign(this, obj);
  }
}
